export default {
  portfolio: {
    title: 'Our Projects',
    projects: {
      ai_valuation: 'AI Property Valuation',
      price_prediction: 'Price Forecasting',
      district_analysis: 'District Market Analysis',
      report_automation: 'Report Automation',
      developer_api_integration: 'Developer API Integration',
      investment_index: 'Investment Attractiveness Indexes'
    }
  }
}
